import { useSearchParams } from "react-router-dom";

const useSearchQuery = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateQuery = (newParams: Record<string, string | number>) => {
    const updatedParams = new URLSearchParams(searchParams);

    Object.entries(newParams).forEach(([key, value]) => {
      if (value) {
        updatedParams.set(key, value.toString());
      } else {
        updatedParams.delete(key);
      }
    });

    setSearchParams(updatedParams);
  };

  const getQueryValue = (paramName: string, defaultValue = "") => {
    return searchParams.get(paramName) || defaultValue;
  };

  const getAllQueryParams = () => {
    const paramsObject: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      paramsObject[key] = value;
    });
    return paramsObject;
  };
  return { updateQuery, getQueryValue, getAllQueryParams };
};

export default useSearchQuery;
